module.exports = "/images/wechatpay.svg";